<div *ngIf="show" style="width:100%;height:10px;">
    <div style="font-size:smaller;">Job en cours ({{index}} / {{count}})</div>
    <mat-progress-bar style="height:8px;" mode="determinate" value="percentage"></mat-progress-bar>
</div>